<template>

    <m-edit1/>

    <m-form-answer-500 v-bind='{...{},...{}}' :style='""' class="" ></m-form-answer-500>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFormAnswer500 from '@moeinmdn/miw-alpha-components/src/package/Form/FormAnswer/FormAnswer500';

export default {
    name: 'HomeView',
    components: {mEdit1, mFormAnswer500 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
